module.exports = "build/assets/linePattern.28db399e.png";